<template>
  <div class="box">
    <div class="header">
      <span class="h1">检测样品</span>
      <span class="h2">交易状态</span>
      <span class="h3">时间</span>
    </div>
    <div class="content">
      <ul ref="scrollUp" :style="{top:top+'px'}">
        <li v-for="(item,index) in showList" :key="index">
          <span class="p1">{{item.name}}</span>
          <span class="p2">{{item.state?'已报价':'已成交'}}</span>
          <span class="p3">{{item.time}}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "sampleDealStatus",
  components: {},
  computed: {},
  props: {

  },
  data () {
    return {
      sampleNameList: ['花生油', '大豆油', '紫苏籽油', '蔬菜脆片'],
      showList: [],//name:样品名称 state:交易状态 time:交易时间
      top:0,
      timer:null
    };
  },
  created () {
    this.getSampleNameList()
  },
  mounted () {
    this.stateScroll()
  },
  destroyed () {
    clearTimeout(this.timer)
  },
  methods: {
    //调后台接口获取样品名称
    getSampleNameList () {
      return this.$api.iotHome.findRealTimeSampleData().then(res=>{
        if (res.data.success == true) {
          this.sampleNameList = res.data.data;
          this.init()
        }
      })
    },
    timeFormate (time) {
      let data = new Date(time)
      let m = data.getMinutes()
      let h = data.getHours()
      if (m < 10) {
        m = '0' + m
      }
      if (h < 10) {
        h = '0' + h
      }
      return `${h}:${m}`
    },
    randomTime () {
      return Math.floor(Math.random() * (10 - 2) + 2) * 60 * 1000
    },
    randomName () {
      let max = this.sampleNameList.length
      let index = Math.floor(Math.random() * max)
      return this.sampleNameList[index]
    },
    randomState () {
      return Math.random() > 0.5 ? 1 : 0
    },
    //初次展示数据
    init () {
      let arr = []
      let now = new Date().getTime()
      for (let i = 0; i < 9; i++) {
        now = now - this.randomTime()
        arr.unshift({
          name: this.randomName(),
          state: this.randomState(),
          time: this.timeFormate(now),
          _time: now
        })
      }
      this.showList = arr
    },
    //开始滚动
    stateScroll (time = 60000) {
      this.timer=setTimeout(() => {
        let now = new Date().getTime()
        this.showList.push({
          name: this.randomName(),
          state: this.randomState(),
          time: this.timeFormate(now),
          _time: now
        })
        this.$nextTick(()=>{
          this.top = this.top-24
        })
        let time = this.randomTime()
        this.stateScroll(time)
      }, time);
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  height: 286px;
  width: 251px;
  padding: 56px 20px 20px 20px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.12);
  .header {
    position: absolute;
    top: 0;
    left: 0;
    height: 46px;
    width: 100%;
    background: #4064ff;
    border-radius: 6px 6px 0 0;
    color: #fff;
    font-weight: bold;
    font-size: 14px;
    line-height: 46px;
    display: flex;
    justify-content: space-around;
  }
  .content {
    width: 100%;
    height: 100%;
    overflow: hidden;
    ul {
      position: relative;
      top: 0;
      transition: top 1s;
      li {
        height: 24px;
        line-height: 24px;
        span {
          display: inline-block;
          font-size: 12px;
          color: #a2a3b4;
          text-align: center;
          width: 70px;
          vertical-align: top;
        }
        .p1 {
          width: 70px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .p2 {
          margin-left: 10px;
          width: 70px;
        }
        .p3 {
          text-align: right;
          width: 60px;
        }
      }
    }
  }
}
</style>
